import React from "react"

import { DateOcrExtractionProvider } from "./DateOcrExtractionProvider"
import { DefaultDateOcrExtractionProvider } from "./DefaultDateOcrExtractionProvider"

/**
 * Holds the OCR provider used by DateExtraction to extract a date from a
 * captured image. A container wires the real provider here; a per-instance
 * `ocrProvider` prop takes precedence when supplied.
 *
 * Defaults to a provider that fails every extraction, so the component has a
 * well-defined provider to call before a real one is wired.
 */
export const DateOcrProviderContext = React.createContext<
  DateOcrExtractionProvider
>(new DefaultDateOcrExtractionProvider())

DateOcrProviderContext.displayName = "DateOcrProviderContext"
